import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { loadStripe, Stripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import axios from "axios";
import { OrderDetails } from "./models";
import PaymentForm from "./PaymentForm";
import { getStripeKey } from "utils/stripeUtil";

let stripePromise: Promise<Stripe | null>
const API_URL = process.env.REACT_APP_API_URL;

const PaymentInstalment: React.FC = () => {
  const location = useLocation();
  const [orderDetails, setOrderDetails] = useState<OrderDetails | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [clientSecret, setClientSecret] = useState<string>("");

  useEffect(() => {
    const fetchOrderDetails = async () => {
      const params = new URLSearchParams(location.search);
      const orderId = params.get("orderId");
      const source = params.get("source");

      if (!orderId) {
        setError("Order ID is missing from the URL.");
        setIsLoading(false);
        return;
      }

      const url = source
        ? `${API_URL}/payment_plan/order?orderId=${orderId}&source=${source}`
        : `${API_URL}/payment_plan/order?orderId=${orderId}`;

      try {
        const response = await axios.get<OrderDetails>(url);
        setOrderDetails(response.data);
        const stripePublishableKey = getStripeKey(response.data.currency);
        stripePromise = loadStripe(stripePublishableKey!);
      } catch (err) {
        setError("Failed to fetch order details");
      } finally {
        setIsLoading(false);
      }
    };

    fetchOrderDetails();
  }, [location]);

  if (isLoading)
    return <div className="text-white text-center">Loading...</div>;
  if (error || !orderDetails)
    return (
      <div className="text-red-500">
        {error || "Failed to load order details"}
      </div>
    );

  return (
    <div className="bg-gray-900 min-h-screen p-4">
      <div className="max-w-2xl mx-auto">
        <h1 className="text-3xl font-bold mb-6 text-white">
          Payment Plan Details
        </h1>
        <Elements 
          stripe={stripePromise}
          options={{
            appearance: {
              theme: "night",
            },
          }}
        >
          <PaymentForm 
            orderDetails={orderDetails} 
            onClientSecretCreated={setClientSecret}
            clientSecret={clientSecret}
            stripePromise={stripePromise}
          />
        </Elements>
      </div>
    </div>
  );
};

export default PaymentInstalment;
